import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=943517de&scoped=true"
import script from "./CategoryItem.vue?vue&type=script&lang=js"
export * from "./CategoryItem.vue?vue&type=script&lang=js"
import style0 from "./CategoryItem.vue?vue&type=style&index=0&id=943517de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943517de",
  null
  
)

export default component.exports